import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, get } from "firebase/database";
import app from "../../backend/firebaseConfig";
import { db } from "../../backend/firebaseConfig";
import {
  doc,
  getDoc,
} from "firebase/firestore";

/**
 * Dashboard for displaying patient info.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} props.patientName - The name of the patient.
 * @param {number} props.age - The age of the patient.
 * @returns {JSX.Element} The rendered dashboard.
 */
export function fetchUserDetails(setUserDetails, explicitUid = null) {
  const auth = getAuth();

const loadUserDetails = async (uid, allowRetry = true) => {
    if (!uid) {
      setUserDetails(null);
      return;
    }

    try {
      const userRef = doc(db, "users", uid);
    const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        const userData = userSnap.data();
        setUserDetails({ id: uid, ...userData });
      } else {
        setUserDetails(null);
      }
    } catch (error) {
    if (error?.code !== "permission-denied") {
      console.error("Error fetching user details:", error);
      }
      setUserDetails(null);
    }
  };

  if (explicitUid) {
    loadUserDetails(explicitUid);
    return () => {};
  }

  return onAuthStateChanged(auth, async (user) => {
    if (user) {
      await loadUserDetails(user.uid);
    } else {
      setUserDetails(null);
    }
  });
}
